import React from "react";
import { AvForm } from "availity-reactstrap-validation";
import {
    CustomCardBody,
    CustomCardFooter,
} from "@components/Common/CustomCardStyled";

import "../index.css";
import { PaymentMethodField } from "./components/PaymentMethodField";
import { DisplayNameField } from "./components/DisplayNameField";
import { CountrySelectField } from "./components/CountrySelectField";
import { SaleSupportField } from "./components/SaleSupportField";
import { TagField } from "./components/TagField";
import { FooterActions } from "./components/FooterActions";
import { usePaymentMethodLogic } from "./hooks/usePaymentMethodLogic";
import { HeaderSection } from "./components/HeaderSection.tsx";
import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import { ConfirmationModificationMessage } from "../../ConfirmationModificationMessage";
import { ConfirmationMessage } from "../../ShopsPaymentMethod/ConfirmationMessage";
import { ConfirmationModal } from "../ConfirmationModal";
import AdvancedDisplayNameModal from "@pages/SettingGeneral/DisplayName/AdvancedDisplayNameModal";
import { store } from "@components/VerticalLayout/store";
import { useSnapshot } from "valtio";
import {
    setActions,
    setIsActionsClicked,
    store as choiceStore,
    setIsEdited,
    setIsLoading,
} from "../../store";
import { addPaymentMethod } from "../hooks";
import { useTranslation } from "react-i18next";
import { generalConfigStore } from "@store";
import { useFetchGlobal } from "../../../../../api/hooks";

const PaymentMethodFormWrapper = (props: any) => {
    const { t } = useTranslation();
    const logic = usePaymentMethodLogic(props);
    const { isActionsClicked } = useSnapshot(choiceStore);
    const { shopID } = useSnapshot(store);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const { fetchGlobal } = useFetchGlobal();
    React.useEffect(() => {
        if (logic.isMessageValidateClicked === true) {
            let id = logic.paymentMethodList.find(
                (elt: any) => elt.label === logic.choiceMode
            ).value;

            let paymentMethod: any = props.allDataShops.find(
                (el: any) => el.id === id
            );
            setIsLoading(true);
            addPaymentMethod({
                id: paymentMethod.id,
                choiceMode: props.paymentMethod[t("Type of payment method")],
                display: logic.display,
                salesSupport: logic.salesSupport.join(","),
                country:
                    logic.countryData.some((substring: any) =>
                        paymentMethod[t("Country")].labels.includes(substring)
                    ) === true
                        ? paymentMethod[t("Country")]
                        : `${paymentMethod[t("Country")].labels.join(
                              ","
                          )},${logic.countryData.join(",")}`,
                tag: logic.tagsData.join(","),
                shopIds: [shopID],
                isActive: false,
                msg: "The Payment method assignment was successful",
                oneShop: true,
                paymentMethodList: logic.paymentMethodList,
                originPaymentMethodList: logic.originPaymentMethodList,
                userData: props.userData,
                operatorID: logic.operatorID,
                uuidUser: logic.uuidUser,
                advancedDisplayName: logic.advancedDisplayName,
                i18nextLng: logic.i18nextLng,
                itemsDisable,
                setIsSendingTag: logic.setIsSendingTag,
                setIsEdited,
                setLocalFilterActive: props.setLocalFilterActive,
                setTagsData: logic.setTagsData,
                setCountryData: logic.setCountryData,
                setSalesSupport: logic.setSalesSupport,
                setDataChoice: props.setDataChoice,
                setAdvancedDisplayName: logic.setAdvancedDisplayName,
                setIsValidateButtonDisabled: logic.setIsValidateButtonDisabled,
                fetchGlobal,
            });
            if (
                logic.countryData.some((substring: any) =>
                    paymentMethod[t("Country")].labels.includes(substring)
                ) === false
            ) {
                addPaymentMethod({
                    id: paymentMethod.id,
                    choiceMode: paymentMethod[t("Type of payment method")],
                    display: paymentMethod[t("Display name")],
                    salesSupport:
                        logic.salesSupport.some((substring: any) =>
                            paymentMethod[t("Support de vente")]
                                .split(",")
                                .includes(substring)
                        ) === true
                            ? paymentMethod[t("Support de vente")]
                            : `${
                                  paymentMethod[t("Support de vente")]
                              },${logic.salesSupport.join(",")}`,
                    country: `${paymentMethod[t("Country")].labels.join(
                        ","
                    )},${logic.countryData.join(",")}`,
                    tag: logic.tagsData.join(","),
                    shopIds: ["0"],
                    isActive: false,
                    msg: "false",
                    oneShop: false,
                    paymentMethodList: logic.paymentMethodList,
                    originPaymentMethodList: logic.originPaymentMethodList,
                    userData: props.userData,
                    operatorID: logic.operatorID,
                    uuidUser: logic.uuidUser,
                    advancedDisplayName: logic.advancedDisplayName,
                    i18nextLng: logic.i18nextLng,
                    itemsDisable,
                    setIsSendingTag: logic.setIsSendingTag,
                    setIsEdited,
                    setLocalFilterActive: props.setLocalFilterActive,
                    setTagsData: logic.setTagsData,
                    setCountryData: logic.setCountryData,
                    setSalesSupport: logic.setSalesSupport,
                    setDataChoice: props.setDataChoice,
                    setAdvancedDisplayName: logic.setAdvancedDisplayName,
                    setIsValidateButtonDisabled:
                        logic.setIsValidateButtonDisabled,
                    fetchGlobal,
                });
            }
            setIsLoading(false);
            logic.setIsMessageValidateClicked(false);
            logic.setIsMessageModalOpened(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.allDataShops,
        props.userData,
        logic.isMessageValidateClicked,
        t,
        logic.choiceMode,
        logic.countryData,
        logic.tagsData,
        logic.salesSupport,
        logic.display,
        logic.paymentMethodList,
        logic,
        props.paymentMethod,
        props.setLocalFilterActive,
        props.setDataChoice,
        shopID,
        itemsDisable,
    ]);

    return (
        <React.Fragment>
            <AvForm className="card">
                <HeaderSection {...logic} {...props} />
                <CustomCardBody
                    className="pl-3 pr-5"
                    style={{ maxHeight: "470px", overflowY: "auto" }}
                >
                    <PaymentMethodField {...logic} {...props} />
                    <DisplayNameField {...logic} {...props} />
                    <CountrySelectField {...logic} {...props} />
                    <SaleSupportField {...logic} {...props} />
                    <TagField {...logic} {...props} />
                </CustomCardBody>

                <CustomCardFooter className="pt-1 pb-2">
                    <FooterActions {...logic} {...props} />
                </CustomCardFooter>
            </AvForm>

            <ConfirmationEditMessage {...logic} {...props} />
            {logic.isPaymentMethodAssociatedModified && (
                <ConfirmationModificationMessage
                    setIsSendingTag={logic.setIsSendingTag}
                    setDataChoice={props.setDataChoice}
                    shopsPaymentMethodsData={logic.shopsPaymentMethodsData}
                    data={logic.data}
                    resetData={logic.resetData}
                    isAddChoiceClicked={props.isAddChoiceClicked}
                    userData={props.userData}
                    setIsAddChoiceClicked={props.setIsAddChoiceClicked}
                    setIsEdited={props.setIsEdited}
                    isModalOpened={logic.isPaymentMethodAssociatedModified}
                    setIsModalOpened={
                        logic.setIsPaymentMethodAssociatedModified
                    }
                    idsAssociated={logic.idsAssociated}
                    salesSupport={logic.salesSupport.join(",")}
                    paymentMethod={props.paymentMethod}
                />
            )}
            {logic.isMessageModalOpened ? (
                <ConfirmationMessage
                    msg={logic.confirmationMessageText}
                    isArchived={logic.isArchived}
                    setIsModalOpened={logic.setIsMessageModalOpened}
                    isModalOpened={logic.isMessageModalOpened}
                    setIsValidateClicked={logic.setIsMessageValidateClicked}
                />
            ) : null}
            {logic.isArchivedFranchiseModalOpened ? (
                <ConfirmationModal {...logic} {...props} />
            ) : null}
            {logic.isAdvancedDisplayNameModalOpen && (
                <AdvancedDisplayNameModal
                    {...logic}
                    {...props}
                    displayName={logic.advancedDisplayName}
                    isActionsClicked={isActionsClicked}
                    setActions={setActions}
                    setIsActionsClicked={setIsActionsClicked}
                />
            )}
        </React.Fragment>
    );
};

export default PaymentMethodFormWrapper;
